var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{class:[_vm.$style.item, _vm.classDevice(_vm.$style)],attrs:{"to":_vm.item.url,"title":_vm.item.title}},[_c('div',{class:[
      _vm.$style.image,
      _vm.classDevice(_vm.$style),
      ( _obj = {}, _obj[_vm.$style.small] = _vm.small, _obj ),
      _vm.classIsMobileType2 ]},[_c('div',{class:_vm.$style.imageInnerWrapper},[_c('component-image',{class:_vm.$style.imageInner,attrs:{"multiply":"","absolute":"","cover":"","aspect-ratio":"3 / 2","alt":_vm.item.title,"image":_vm.item.image}})],1)]),_vm._v(" "),_c('div',{class:[_vm.classTitle, _vm.classDevice(_vm.$style)]},[_vm._v(_vm._s(_vm.item.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }